module.exports = __webpack_public_path__ + "static/media/bloop.a5c4a9e6.mp3";